import React, { Component } from "react"
import NavItem from "./NavItem"
import UserMenu from "../UserMenu"
import { Navbar, Collapse, NavbarBrand, Nav } from "reactstrap"

class NavBarComponent extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isOpen: false
        }
        this.toggleNavBar = this.toggleNavBar.bind(this)
        this.onNavItemClick = this.onNavItemClick.bind(this)
    }

    toggleNavBar() {
        this.setState({
            isOpen: !this.state.isOpen
        })
    }

    onNavItemClick(routeId, link) {
        this.setState({
            isOpen: false
        })
        this.props.onNavItemClick(routeId, link)
    }

    render() {
        const { navbarItems, activeLocation } = this.props
        return (
            <div className="sidebar-nav">
                <Navbar color="inverse" dark expand="custom-lg">
                    <button
                        className={`navbar-toggle ${
                            this.state.isOpen ? "navbar-toggle--active" : ""
                        }`}
                        onClick={this.toggleNavBar}
                    >
                        <span className="icon-bar" />
                        <span className="icon-bar" />
                        <span className="icon-bar" />
                    </button>

                    <div className="navbar-header">
                        <NavbarBrand href="/" />
                    </div>
                    <UserMenu />
                    <Collapse isOpen={this.state.isOpen} navbar>
                        <Nav className="mr-auto" navbar>
                            {navbarItems.map((route, index) => (
                                <NavItem
                                    key={index}
                                    route={route}
                                    routeId={index}
                                    isActive={
                                        activeLocation.indexOf(route.link) === 0
                                    }
                                    onClick={this.onNavItemClick}
                                />
                            ))}
                        </Nav>
                    </Collapse>
                </Navbar>
            </div>
        )
    }
}

export default NavBarComponent
